<template>
    <nav id="sidebar" class="sidebar sidebar-wrapper">
        <div class="sidebar-content">
            <h4 tabindex="0" class="text-white menu-header">Menú</h4>
            <div class="sidebar-brand"> </div>
            <div class="sidebar-menu">
                <ul id="js-navigation">
                    <li class="sidebar-dropdown linkactivo border-top">
                        <router-link to="/" class="link itemNavContenido">Elementos de contextualización</router-link>
                    </li>
                    <li class="sidebar-dropdown">
                        <a href="#"> Contenido<span class="icon-siguiente flechamenu float-right cerrado "
                                style="pointer-events: none;"></span> </a>
                        <div class="sidebar-submenu">
                            <ul>
                                <li class="sidebar-item">
                                    <router-link to="/accionProblemica" class="link itemNavContenido">Acción problémica</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/conocimientosPrevios" class="link itemNavContenido">Conocimientos previos</router-link>
                                </li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 1</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema1" class="link itemNavContenido">1. Teorías del desarrollo</router-link>
                                            <router-link to="/Tema1_1.1" class="link itemNavContenido">1.1. Historia del desarrollo</router-link>
                                            <router-link to="/Tema1_1.2" class="link itemNavContenido">1.2. La psicología del desarrollo</router-link>
                                        </ul>
                                    </div>
								</li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 2</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema2" class="link itemNavContenido">2. Teoría del desarrollo de Piaget</router-link>
                                            <router-link to="/Tema2_2.1" class="link itemNavContenido">2.1. Estadios del desarrollo  </router-link>
                                        </ul>
                                    </div>
								</li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 3</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema3" class="link itemNavContenido">3. Desarrollo desde la perspectiva de Vygotsky</router-link>
                                            <router-link to="/Tema3_3.1" class="link itemNavContenido">3.1. Juego y zona de desarrollo</router-link>
                                            <router-link to="/Tema3_3.2" class="link itemNavContenido">3.2. El pensamiento simbólico y el juego</router-link>
                                        </ul>
                                    </div>
								</li>
                                <li class="sidebar-dropdown">
                                    <router-link to="#" class="link">Tema 4</router-link>
                                    <div class="sidebar-submenu">
                                        <ul>
                                            <router-link to="/Tema4" class="link itemNavContenido">4. Dimensiones del desarrollo desde la perspectiva cultural</router-link>
                                            <router-link to="/Tema4_4.1" class="link itemNavContenido">4.1. Procesos de formación de la palabra</router-link>
                                        </ul>
                                    </div>
								</li>
                               
                                 <li class="sidebar-item"> 
                                    <router-link to="/actividadSeguimiento" class="link itemNavContenido">Actividad de seguimiento</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/autoEvaluacion" class="link itemNavContenido">Autoevaluación</router-link>
                                </li>
                                <li class="sidebar-item"> 
                                    <router-link to="/finUnidad" class="link itemNavContenido">Fin de la unidad</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="sidebar-dropdown"> 
                        <router-link to="/referenciasBibliograficas" class="link itemNavContenido">Referencias bibliográficas</router-link>
                    </li>
                    <li class="sidebar-dropdown"> 
                        <router-link to="/creditos" class="link itemNavContenido">Créditos</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>


<script>

//Importamos la funcion navigation 
import {Navigation} from '../assets/RecursosITM/common/js/itm'

export default {
    name: 'Nav',
    mounted(){
        Navigation()
    }
}
</script>